var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 139,
    viewBox: "0 0 322 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.736 -76.2855C302.115 -47.1837 328.401 -17.947 313.811 11.0618C299.075 40.3621 251.069 41.1377 223.114 62.1403C194.977 83.2793 185.756 125.299 150.72 133.591C116.035 141.8 87.7128 113.921 56.3979 101.599C25.0049 89.2467 -19.6336 88.9357 -33.365 61.1557C-47.2988 32.9664 -15.4031 0.742002 -9.02122 -30.7494C-3.655 -57.2291 -10.6831 -83.7186 1.10546 -108.94C14.9446 -138.548 31.1056 -171.864 63.6978 -186.328C96.4065 -200.844 133.176 -188.248 167.707 -182.876C200.617 -177.756 236.581 -175.782 260.04 -155.782C283.213 -136.027 283.78 -104.073 292.736 -76.2855Z",
    stroke: "#B000FF",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorPurple);
export default __webpack_public_path__ + "static/media/vector_purple.73748e49dbbff432296db8e2cc92d504.svg";
export { ForwardRef as ReactComponent };